import type { KidDiscipline, KidDisciplineStorePayload } from '../model/interfaces'
import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

import { useKidStore } from '../model/store'

/** `POST /admin-api/disciplines` — adds a MATH or ELA discipline the kid does not have yet. */
export const useKidDisciplineStoreApi = async (payload: KidDisciplineStorePayload): Promise<KidDiscipline | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()
  const kidStore = useKidStore()

  const url = useAdminRoutes('admin.kid.disciplines.store')

  kidStore.trackProcessing(true)

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.post<ApiResponse>(url, payload)

    if (!data.success) {
      toast.error(data.message)
      return null
    }

    toast.success(data.message)

    return data.data as KidDiscipline
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return null
  } finally {
    kidStore.trackProcessing(false)
  }
}
